
import { Create, SimpleForm, TextInput, DateInput, NumberInput } from 'react-admin';

export const Tbl_cartellinoCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <NumberInput source="partitaId" />
            <NumberInput source="playerId" />
            <NumberInput source="tipoCartellinoId" />
            <NumberInput source="minuto" />
            <TextInput source="note" />
            <NumberInput source="flVisibile" />
            <NumberInput source="flAttivo" />
            <NumberInput source="flAnnullato" />
            <NumberInput source="ordinamento" />
            <DateInput source="createdAt" />
            <DateInput source="updatedAt" />
        </SimpleForm>
    </Create>
);
            